import { Component, Inject, OnInit } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from "@app/models/util/paginacao";

import { Rito } from '@app/models/rito.model';
import { RitoService } from '@app/services/rito.service';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-rito-lista',
  templateUrl: './rito-lista.component.html'
})
export class RitoListaComponent implements OnInit {

  filtroDescricao: string = "";
  bsModalRef: BsModalRef;
  paginacao: Paginacao = new Paginacao();
  lstRito: Rito[];

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private ritoService: RitoService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.ritoService.obterLista(descricao, pagina).toPromise().then(data => {
      this.lstRito = data.Dados,
        this.paginacao.totalDeItens = data.Total
    },
      erro => {
        //this.loading = false;
        this.toastr.warning("Realize a pesquisa novamente.")
      });
  }

  deletar(rito: Rito) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = "Deseja realmente excluir o rito: " + rito.Descricao + "?";
    this.bsModalRef.content.confirmar = () => {
      this.ritoService.deletar(rito.Id).toPromise().then(
        () => {
          this.obterTodos(this.filtroDescricao, 1);
          this.paginacao.paginaAtual = 1;
        });
    };
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }

}
